import { useEffect, useState } from "react";
import { Tabs } from "../interfaces/GlobalContext.interface";
import useBrowserMode from "../shared/hooks/useBrowserMode";

export const useSelectTab = () => {
  const { isBrowser } = useBrowserMode();
  const [selectedTab, setSelectedTab] = useState<Tabs | undefined>();

  useEffect(() => {
    if (isBrowser) {
      const valueSelection = localStorage.getItem("select-tab") || "";
      setSelectedTab(valueSelection as Tabs);
    }
  }, []);

  const setSelectionToLocalStorage = (selection: Tabs) => {
    localStorage.setItem("select-tab", `${selection}`);
    setSelectedTab(selection);
  };

  return {
    selectedTab,
    setSelectionToLocalStorage,
  };
};
